import { HttpParams } from '@angular/common/http'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, ListItem, ModalSize, SafetyWorkAloneAuth, VpUser } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { SafetyWorkAloneAuthComponent } from './safety-work-alone-auth.component'

@Component({
    selector: 'app-safety-work-alone-auths',
    templateUrl: './safety-work-alone-auths.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class SafetyWorkAloneAuthsComponent extends BaseComponent {
    public grid: Grid<SafetyWorkAloneAuth>

    employeeMap!: DataMap
    activeEmployeeList: ListItem<number>[] = []
    allEmployees: VpUser[] = []

    constructor() {
        super()
        this.grid = new Grid<SafetyWorkAloneAuth>(this.services)
            .setupModalEditing(
                this.services.data.safetyWorkAloneAuths,
                'Work Alone Authorization',
                SafetyWorkAloneAuthComponent,
                () => SafetyWorkAloneAuth.createNew(),
                this,
                ModalSize.extraLarge,
            )
            .wrapColumnHeaders()
            .filterBy(item => [
                item.siteLocation,
                item.jobDescription,
                item.lengthOfTime,
                item.communicationMethod,
                item.emergencyContact1,
                item.emergencyContact2,
                item.emergencyContact3,
                this.employeeMap?.getDisplayValue(item.employeeHrRef),
            ])
        this.grid.canEdit = this.canEdit
        this.grid.canAdd = this.canEdit
        this.grid.canDelete = this.canEdit
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get<VpUser[]>('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', true)),
                    this.services.data.get<VpUser[]>('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', false)),
                    this.services.data.safetyWorkAloneAuths.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()

                        const activeUsers = result[0] as VpUser[]
                        this.allEmployees = result[1] as VpUser[]
                        this.activeEmployeeList = activeUsers
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map(u => new ListItem(u.id, u.name))
                        this.employeeMap = new DataMap(this.allEmployees, 'id', 'name')
                        this.grid.items = result[2] as SafetyWorkAloneAuth[]
                    },
                }),
        )
    }

    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistEdit])
    }
}
